@let editing = feature.selectors.editingSession.asSignal();
@let agentId = editing?.agentId;
@let conversationId = editing?.conversationId;
@let mode = modeSg();

@let isSubmitting =
  !!agentId &&
  (feature.selectors.agentDefaultIsSubmitting(agentId).asSignal() ||
    (conversationId
      ? feature.selectors
          .conversationOverrideIsSubmitting(conversationId)
          .asSignal()
      : false));
@let isLoading =
  !!agentId &&
  (feature.selectors.agentDefaultIsLoading(agentId).asSignal() ||
    (conversationId
      ? feature.selectors
          .conversationOverrideIsLoading(conversationId)
          .asSignal()
      : false));
@let draftAgent = feature.selectors.editingAgentDraft.asSignal();
@let draftConversation = feature.selectors.editingConversationDraft.asSignal();
@let stored =
  conversationId
    ? feature.selectors.conversationOverrideValue(conversationId).asSignal()
    : undefined;

<atn-ds-centered-overlay
  type="wide"
  (backdropClick)="
    feature.actions.stopEditing
      .from('AssistantConfigurationModal.close')
      .dispatch()
  "
>
  <atn-ds-widget title="Configure agent context">
    <i
      actions
      class="atn-icon atn-close atn-red"
      (click)="
        feature.actions.stopEditing
          .from('AssistantConfigurationModal.close')
          .dispatch()
      "
    ></i>

    <div class="atn-assistant-configuration__body">
      <atn-ds-integrated-horizontal-tabs
        (selectedTabChange)="
          modeSg.set($event?.index === 0 ? 'agent' : 'conversation')
        "
      >
        <ng-template
          atnDsTab
          name="Agent default"
          [isInitiallySelected]="!conversationId"
        >
          <div class="atn-assistant-configuration__tab">
            <p class="atn-assistant-configuration__tab-hint">
              Default context applied to every conversation with this agent.
            </p>
            <atn-assistant-configuration-form mode="agent" />
          </div>
        </ng-template>

        @if (conversationId) {
          <ng-template
            atnDsTab
            name="This conversation"
            [isInitiallySelected]="true"
          >
            <div class="atn-assistant-configuration__tab">
              <p class="atn-assistant-configuration__tab-hint">
                Overrides the agent default for the active conversation only.
              </p>
              <atn-assistant-configuration-form mode="conversation" />
            </div>
          </ng-template>
        }
      </atn-ds-integrated-horizontal-tabs>
    </div>

    <div
      footer
      class="atn-assistant-configuration__footer"
    >
      <atn-ds-button
        type="transparent"
        [disabled]="isLoading || isSubmitting"
        (click)="
          feature.actions.stopEditing
            .from('AssistantConfigurationModal.close')
            .dispatch()
        "
      >
        Cancel
      </atn-ds-button>
      @if (conversationId && mode === 'conversation') {
        <atn-ds-button
          type="transparent"
          [disabled]="isLoading || isSubmitting || !draftConversation"
          (click)="
            stored
              ? feature.actions.deleteOverride
                  .from('AssistantConfigurationModal.resetConversationOverride')
                  .execute({
                    agentId: stored.agentId,
                    conversationId: conversationId!,
                  })
              : feature.actions.setConversationDraft
                  .from('AssistantConfigurationModal.resetConversationOverride')
                  .dispatch({ context: undefined })
          "
        >
          Reset to inherited
        </atn-ds-button>
        <atn-ds-button
          [loading]="isLoading || isSubmitting"
          (click)="
            feature.actions.save
              .from('AssistantConfigurationModal.saveConversationOverride')
              .execute({
                agentId: agentId!,
                context: draftConversation ?? {},
                key: { conversationId },
              })
          "
        >
          Save for conversation
        </atn-ds-button>
      } @else {
        <atn-ds-button
          [loading]="isLoading || isSubmitting"
          (click)="
            feature.actions.save
              .from('AssistantConfigurationModal.saveAgentDefault')
              .execute({
                agentId: agentId!,
                context: draftAgent ?? {},
                key: { agentId: agentId! },
              })
          "
        >
          Save default
        </atn-ds-button>
      }
    </div>
  </atn-ds-widget>
</atn-ds-centered-overlay>
